<div class="form-group" *ngFor="let groupPermission of userGroupPermissions">
  <label>{{ groupPermission.userGroup.name }}</label>
  <comm-tsq-radio-inline
    [options]="options"
    [selected]="getSelected(groupPermission.permission)"
    (selectedChange)="onSelectChange(groupPermission.userGroup, $event.value)"
  />
</div>
